import React from 'react'
import Trans from 'next-translate/Trans'

import dynamic from 'next/dynamic'

const EllipsisToolTip = dynamic(() => import('ellipsis-tooltip-react-chan'), { ssr: false })

const MultipleSalesInvoiceToCompany = ({ toCompany }) => (
  <>
    <p className="text-uppercase mb-10 ls-1"><strong><Trans i18nKey="salesInvoice:shipper_info" /></strong></p>
    <p>
      {toCompany?.name}
      {' '}
      <br />
      <span className="conform-email">
        <EllipsisToolTip options={{ className: 'custom-color-tooltip' }}>
          {toCompany?.email}
        </EllipsisToolTip>
      </span>
    </p>
    <p>
      <Trans i18nKey="salesInvoice:vat_code" />:
      {' '}
      {toCompany?.nifWithCountry || toCompany?.nif}
      {' '}
      <br />
      <Trans i18nKey="salesInvoice:address" />:
      {' '}
      {toCompany?.invoiceAddress}
    </p>
  </>
)

export default MultipleSalesInvoiceToCompany
